import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import Dropdown from 'atoms/dropdown';
import { setSelectedGroomer } from 'store/reducers/ui';
import { capitalizeFirstLetter } from 'util';
import { viewAllGroomersOption } from 'util/constants';

import { UserAvatarExtraSmall } from './UserAvatar';

export default function GroomersDropdown({
  className,
  disableAllOption,
  Element = UserAvatarExtraSmall,
}) {
  const dispatch = useDispatch();
  const { selectedGroomer } = useSelector((state) => state.ui);
  const { groomers } = useSelector((state) => state.groomers);
  const groomersDropdownOptions = groomers.map(({ user }) => ({
    name: capitalizeFirstLetter(user.firstName),
    links: user.links,
    uuid: user.uuid,
  }));

  const options = disableAllOption
    ? groomersDropdownOptions
    : [viewAllGroomersOption, ...groomersDropdownOptions];

  const onSelectGroomer = (groomer) => dispatch(setSelectedGroomer(groomer));

  return (
    <Dropdown
      id="actions"
      variant="white"
      size="extra-small"
      shape="round"
      className={classNames('groomers-dropdown', className)}
      items={options}
      value={
        disableAllOption && selectedGroomer.uuid === 'all'
          ? 'Select a groomer'
          : capitalizeFirstLetter(selectedGroomer.name)
      }
      CustomContent={Element}
      onClick={onSelectGroomer}
    />
  );
}
